import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { createElement } from "@wordpress/element";

/**
 * External dependencies
 */
import classnames from 'classnames';
import { flatMap } from 'lodash';
/**
 * Internal dependencies
 */

import ToolbarButton from '../toolbar-button';
import DropdownMenu from '../dropdown-menu';
import ToolbarContainer from './toolbar-container';
/**
 * Renders a toolbar with controls.
 *
 * The `controls` prop accepts an array of sets. A set is an array of controls.
 * Controls have the following shape:
 *
 * ```
 * {
 *   icon: string,
 *   title: string,
 *   subscript: string,
 *   onClick: Function,
 *   isActive: boolean,
 *   isDisabled: boolean
 * }
 * ```
 *
 * For convenience it is also possible to pass only an array of controls. It is
 * then assumed this is the only set.
 *
 * Either `controls` or `children` is required, otherwise this components
 * renders nothing.
 *
 * @param {Object}        props
 * @param {Array}        [props.controls]  The controls to render in this toolbar.
 * @param {ReactElement} [props.children]  Any other things to render inside the
 *                                         toolbar besides the controls.
 * @param {string}       [props.className] Class to set on the container div.
 *
 * @return {ReactElement} The rendered toolbar.
 */

function Toolbar(_ref) {
  var _ref$controls = _ref.controls,
      controls = _ref$controls === void 0 ? [] : _ref$controls,
      children = _ref.children,
      className = _ref.className,
      isCollapsed = _ref.isCollapsed,
      icon = _ref.icon,
      label = _ref.label,
      otherProps = _objectWithoutProperties(_ref, ["controls", "children", "className", "isCollapsed", "icon", "label"]);

  if ((!controls || !controls.length) && !children) {
    return null;
  } // Normalize controls to nested array of objects (sets of controls)


  var controlSets = controls;

  if (!Array.isArray(controlSets[0])) {
    controlSets = [controlSets];
  }

  if (isCollapsed) {
    return createElement(DropdownMenu, {
      hasArrowIndicator: true,
      icon: icon,
      label: label,
      controls: controlSets,
      className: classnames('components-toolbar', className)
    });
  }

  return createElement(ToolbarContainer, _extends({
    className: classnames('components-toolbar', className)
  }, otherProps), flatMap(controlSets, function (controlSet, indexOfSet) {
    return controlSet.map(function (control, indexOfControl) {
      return createElement(ToolbarButton, _extends({
        key: [indexOfSet, indexOfControl].join(),
        containerClassName: indexOfSet > 0 && indexOfControl === 0 ? 'has-left-divider' : null
      }, control));
    });
  }), children);
}

export default Toolbar;
//# sourceMappingURL=index.js.map